import * as api from 'ego-sdk-js';
import React from 'react';

import * as Config from '../../config';
import * as util from '../../util';
import useLoggedInUserId from './useLoggedInUserId';

const statusCallback = (statusCode: number) => {
  if (statusCode === 401) {
    util.deleteCookie('sessionid');
    util.deleteCookie('user_id');
    util.deleteCookie('username');
    util.deleteCookie('is_staff');
    window.location.href = '/login?next=' + window.location.pathname;
  }
};

const useApiClient = () => {
  const loggedInUserId = useLoggedInUserId();
  let apiAuth: api.Auth;
  if (loggedInUserId) {
    apiAuth = { kind: api.AuthKind.Cookie, userId: loggedInUserId };
  } else {
    apiAuth = { kind: api.AuthKind.NoAuth };
  }
  return React.useMemo(
    () => new api.SuperegoClient(Config.apiHost, apiAuth, statusCallback),
    [Config.apiHost, loggedInUserId],
  );
};

export const useAuthedApiClient = () => {
  const loggedInUserId = useLoggedInUserId();
  if (!loggedInUserId) {
    throw Error('Expected user to be logged-in.');
  }
  return React.useMemo(
    () => new api.SuperegoClient(Config.apiHost, { kind: api.AuthKind.Cookie, userId: loggedInUserId }, statusCallback),
    [Config.apiHost, loggedInUserId],
  );
};

export const useNoAuthApiClient = (loggedInOk?: boolean) => {
  const loggedInUserId = useLoggedInUserId();
  if (!loggedInOk && loggedInUserId) {
    throw Error('Expected user to be logged-out.');
  }
  return React.useMemo(
    () => new api.SuperegoClient(Config.apiHost, { kind: api.AuthKind.NoAuth }, statusCallback),
    [Config.apiHost],
  );
};

export default useApiClient;
